import React, { Component } from 'react';
import { connect }          from 'react-redux';
import { MenuItem }         from 'react-bootstrap';
import LinkContainer        from '../../../container/LinkContainer';
import { logout }           from '../../../actions/authenticActions';
import { AlunoPontuacao }       from '../../../actions/usuarioAction';
import { GetListNotificacao,
         SetStatusTalentos,
         SetStatusAcessoDiario 
       }                        from  '../../../actions/notificacaoAction';
import Notificacao_Card         from '../notificacao/notificacao_card';
import logo                from "../../../img/topo/logo.svg";

class topo extends Component {

    constructor(props){
        super(props)
        this.handleSelect =  this.handleSelect.bind(this);
    }

    handleSelect(key) {
        this.props.logout();
    }

    componentWillMount(){

            this.props.AlunoPontuacao(this.props.session.id,this.props.session.curso);
        
            this.props.GetListNotificacao(this.props.session.id,this.props.session.curso).then((response)=>{
                if(localStorage.getItem("novo_talento")){
                   this.props.SetStatusTalentos();
                   localStorage.removeItem('novo_talento');
                }
    
                if(localStorage.getItem("acesso_diario")){
                   this.props.SetStatusAcessoDiario();
                   localStorage.removeItem('acesso_diario');
                }
            })
         
    }

    render() {
      
        return (<div className="hud-top">
                    <img className="logo" src={logo} alt="Gamifica" />
                    <div className="btn-group navbar-right nav-user" role="group" aria-label="...">
                        <div className="btn-group" role="group">
                            <button type="button" className="btn btn-link dropdown-toggle pull-left" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <img width={30} height={30} className="img-circle" src={this.props.session.foto} alt="Image" />
                            </button>
                            <ul className="dropdown-menu">
                                
                              <MenuItem style={{'cursor': 'default'}}><span className="glyphicon glyphicon-user"></span> <b>{this.props.session.nome}</b></MenuItem>
                           
                            <LinkContainer to={this.props.menu.perfil.home}>
                               <MenuItem><span className="glyphicon glyphicon-pencil"></span> <b>Editar Perfil/Foto</b></MenuItem>
                            </LinkContainer>
                            <LinkContainer to="/login" onClick = {this.handleSelect}>
                               <MenuItem><span className="glyphicon glyphicon-log-in"></span> <b>Sair</b></MenuItem>
                            </LinkContainer>
                            </ul>
                        </div>
                    </div>
                    <Notificacao_Card/>
                </div>
                );
    }
}

function mapStateToProps(state){
    return {
             session : state.auth.session,
             menu    : state.configReducer.menu,
             config  : state.configReducer.config
            }
}

export default connect(mapStateToProps,{logout,GetListNotificacao,SetStatusTalentos,SetStatusAcessoDiario,AlunoPontuacao})(topo);




// WEBPACK FOOTER //
// ./src/components/aluno/topo/topo.js